import { ToastProvider, WidgetStateCopyProvider } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import Dashboards from './domains/dashboards';
import { useTranslatedWidgetStateCopy } from './domains/dashboards/hooks';

/**
 * Root component of the Dashboards application.
 * Mounted by the Core Shell under <Route path="dashboards/*">.
 * Also usable standalone via main.jsx.
 */
const DashboardsApp = () => {
  const { ready } = useTranslation('dashboards');
  // One provider for the whole app: every empty or failed card reads the
  // same translated sentence, whichever of the three paths decided it
  // (CT-5885).
  const widgetStateCopy = useTranslatedWidgetStateCopy();

  if (!ready) {
    return (
      <div className="flex flex-1 items-center justify-center text-sm text-content-muted">
        Loading…
      </div>
    );
  }

  return (
    <ToastProvider
      config={{
        position: 'top-right',
        defaultDuration: 4000,
        defaultMaxWidth: '600px',
        defaultMinWidth: '600px',
      }}
    >
      <WidgetStateCopyProvider value={widgetStateCopy}>
        <div className="flex h-full flex-1 flex-col overflow-hidden">
          <Dashboards />
        </div>
      </WidgetStateCopyProvider>
    </ToastProvider>
  );
};

export default DashboardsApp;
